<template>
  <v-toolbar class="myToolbar" :color="appColor" flat dense dark height="32px">
    <v-btn style="position: absolute; left: 0;" v-if="isWebapp == 'false'" icon @click.prevent="closePanel" class="pfo-closebutton">
      <v-icon small style="font-weight: bold;" color="rgba(250, 250, 250, 0.8)">close</v-icon>
    </v-btn>
    <!-- <div class="txtsmall">{{version}}</div> -->
    <v-btn v-if="displaySettings" icon @click.prevent="showSettings" >
      <v-icon small color="rgba(250, 250, 250, 1)">tune</v-icon>
    </v-btn>

    <v-spacer></v-spacer>

    <div style="font-size: 13px;" class="text-center subheading font-weight-regular montserrat">{{appTitle}}</div>

    <v-spacer></v-spacer>

    <!--<v-btn icon @click="closePanel">-->
    <v-tooltip v-if="displayPerfumeDetails" bottom :color="appColor">
      <template v-slot:activator="{ on }">
        <v-btn style="position: absolute; right: 0;" icon @click.prevent="refreshSearch">
          <v-icon color="rgba(250, 250, 250, 1)" v-on="on">refresh</v-icon>
        </v-btn>
      </template>
      <span>{{refresh}}</span>
    </v-tooltip>
    
    <!--<v-btn icon @click="closePanel">-->

  </v-toolbar>
</template>
<script>
  export default {
    name: 'HeaderBar',
    methods: {
      closePanel() {
        this.$emit('close-panel2')
      },
      showElasticSearch() {
        this.$emit('show-elasticsearch')
      },
      refreshSearch() {
        this.$emit('refresh')
      },
      showSettings() {
        this.$emit('show-settings')
      }
    },
    props: {
      displayPerfumeDetails: {
        type: Boolean
      },
      isMobile: {
        type: Boolean,
        default: () => false
      }
    },
    computed: {
      redColor () {
        return process.env.VUE_APP_COLOR
      },
      appColor() {
        return process.env.VUE_APP_COLOR
      },
      appTitle() {
        return process.env.VUE_APP_TITLE
      }
    },
    created: function () {
      if (process.env.VUE_APP_IS_WEBAPP) {
        this.isWebapp = process.env.VUE_APP_IS_WEBAPP
      }
      if (process.env.VUE_APP_OVERRIDE_LOCALE === "true") {
        if (JSON.parse(localStorage.getItem('settingsPFO'))===true) {
          this.locale = JSON.parse(localStorage.getItem('langSET'))
          localStorage.setItem('langPFO', JSON.stringify(this.locale))

          this.country = JSON.parse(localStorage.getItem('countrySET'))
        }
      }
      else {
        if (localStorage.getItem('langPFO')) {
          this.locale = JSON.parse(localStorage.getItem('langPFO'))
        }

        if (localStorage.getItem('countryPFO')) {
          this.country = JSON.parse(localStorage.getItem('countryPFO'))
        }
      }
    },
    data () {
      return {
        version: 0.1,
        title: 'PERFUMIST',
        displaySettings: false,
        locale: null,
        country: null,
        refresh: process.env.VUE_APP_REFRESH
      }
    },
    mounted() {
      if (process.env.VUE_APP_VERSION) {
        this.version = process.env.VUE_APP_VERSION
      }
      if (process.env.VUE_APP_VIEW_SETTINGS) {
        if (process.env.VUE_APP_OVERRIDE_LOCALE === "true") {
          this.displaySettings = true
        }
        else {
          this.displaySettings = false
        }
      }
      if (process.env.VUE_APP_REFRESH) {
        console.log(this.locale)
        if (this.locale==='en') this.refresh =  process.env.VUE_APP_REFRESH_EN || process.env.VUE_APP_REFRESH
        if (this.locale==='fr') this.refresh =   process.env.VUE_APP_REFRESH_FR || process.env.VUE_APP_REFRESH
        if (this.locale==='es') this.refresh =   process.env.VUE_APP_REFRESH_ES || process.env.VUE_APP_REFRESH
        if (this.locale==='de') this.refresh =   process.env.VUE_APP_REFRESH_DE || process.env.VUE_APP_REFRESH
        if (this.locale==='ja') this.refresh =  process.env.VUE_APP_REFRESH_JA || process.env.VUE_APP_REFRESH
        if (this.locale==='ar') this.refresh =  process.env.VUE_APP_REFRESH_AR || process.env.VUE_APP_REFRESH
        if (this.locale==='pt') this.refresh =  process.env.VUE_APP_REFRESH_PT|| process.env.VUE_APP_REFRESH
        if (this.locale==='sv') this.refresh =  process.env.VUE_APP_REFRESH_SV|| process.env.VUE_APP_REFRESH
        if (this.locale==="ru") this.refresh =   process.env.VUE_APP_REFRESH_RU|| process.env.VUE_APP_REFRESH
        if (this.locale==="tr") this.refresh =   process.env.VUE_APP_REFRESH_TR|| process.env.VUE_APP_REFRESH
        if (this.locale==="ms") this.refresh =   process.env.VUE_APP_REFRESH_MS|| process.env.VUE_APP_REFRESH
        if (this.locale==="it") this.refresh =  process.env.VUE_APP_REFRESH_IT|| process.env.VUE_APP_REFRESH
        if (this.locale==="ko") this.refresh =   process.env.VUE_APP_REFRESH_KO|| process.env.VUE_APP_REFRESH
        if (this.locale==="nl") this.refresh =  process.env.VUE_APP_REFRESH_NL|| process.env.VUE_APP_REFRESH
        if (this.locale==="th") this.refresh =  process.env.VUE_APP_REFRESH_TH|| process.env.VUE_APP_REFRESH

        this.refresh = process.env.VUE_APP_REFRESH
      }
    }
  }
</script>
<style>
.myToolbar {
  width: 99% !important;
  margin-left: auto;
  margin-right: auto;
  border-radius: 7px !important;
  margin-top: 5px !important;
  flex: 0;
}
.txtsmall {
  font-size: 12px;
}
.title {
  position: absolute;
  text-align: center;
  left: 0;
  width: 100%;
}
.montserrat {
  font-family: 'Montserrat', sans-serif;
}
.pfo-closebutton {
  border-style: none !important;
  background: unset !important;
}
.v-btn >>> button {
  border: none !important;
}
</style>